import React, {useState} from 'react';
import {motion} from "framer-motion";
import './App.css';
import Rating from "./component/Rating";
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import {whoAmI, WhoYouAre} from "./lib/WhoAmI";
import ScrollIndicator from "./component/scrollindicator/ScrollIndicator";
import Category from "./component/Category";

const firebaseConfig = {
    apiKey: "AIzaSyDqpq-s0HYEed8ZTRcJ90MyltGbz_RkVjo",
    authDomain: "appleorandroid-5880d.firebaseapp.com",
    projectId: "appleorandroid-5880d",
    storageBucket: "appleorandroid-5880d.appspot.com",
    messagingSenderId: "181536406662",
    appId: "1:181536406662:web:c6d2b721254106a1eda507",
    measurementId: "G-T08TWQ1SSH"
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

function App() {

    const [customization, setCustomization] = useState<number>(0);
    const [features, setFeatures] = useState<number>(0);
    const [apps, setApps] = useState<number>(0);

    const [excitement, setExcitement] = useState<number>(0);

    const [updates, setUpdates] = useState<number>(0);

    const [easeOfUse, setEaseOfUse] = useState<number>(0);

    const [ecoSystem, setEcoSystem] = useState<number>(0);


    const typeOfPerson: WhoYouAre = whoAmI( {
        customization,
        features,
        apps,
        excitement,
        updates,
        easeOfUse,
        ecoSystem,
    })


    return (
    <div className="App">
        <div className={"headingPage"}>
            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{duration: 3.0}}
            >
                <h1>
                    This website, based on your input tells you if you should buy an iphone or an android.
                </h1>

                <div>
                    <p>
                        This website is based on MKBHD's youtube video.
                    </p>
                    <p>
                        You will be asked to rate 7 sections from 1 to 5. Based on those ratings we will recommend which eco system is best for you. ios or android.
                    </p>
                    <p>
                        To get accurate rating, <b>do not</b> rate everything 5.
                    </p>


                </div>
                <ScrollIndicator />
            </motion.div>

        </div>

        <Category>
            <h1>Customization</h1>
            <p>
                Out of 5 how important is customization, Imagine custom icon set, fancy wall papers that move according to your accelerometer.
            </p>
            <Rating name={"customization"} onRatingChange={setCustomization} />
        </Category>

        <Category>
            <h1>Features</h1>
            <p>
                Think about charge sharing, wireless charging, 10x zoom lens. Tell us out of 1 to 5 how important are these features.
            </p>
            <Rating name={"features"} onRatingChange={setFeatures} />
        </Category>
        <Category>
            <h1>Ease of Use</h1>
            <p>
                How important is just works. Intuitive, straight forward stuff. Once you learn you dont have to relearn and it stays the same way. Also think about not having bloatware software, occasionally annoying imposition from these software.
            </p>
            <Rating name={"easeOfUse"} onRatingChange={setEaseOfUse} />
        </Category>
        <Category>
            <h1>Updates</h1>
            <p>How long do you want to use the phone? If you would like to use your phone for 3-5 years range it is better to be equipped with latest and greatest software till the 3-5 year mark. How important is it to you to have the latest and greatest software ios or android till the last day of switch?</p>
            <p>
                And also think about customer support, how important is it you that when you face a problem to get it fixed smoothly? Its about smooth process, android does have system in which you can send them phone via mail where shipping labels are included, etc. Its about the extra step that you have to take. So how important is that to you ?
            </p>
            <Rating name={"updates"} onRatingChange={setUpdates} />
        </Category>
        <Category>
            <h1>Apps</h1>
            <p>
                Experience of using apps, Think about quality of apps, their latest version to be available on your phone. Think about having less buggy apps etc.
            </p>
            <Rating name={"apps"} onRatingChange={setApps} />
        </Category>
        <Category>
            <h1>Excitement</h1>
            <p>
                Think about crazy new features, and exciting features. Like a folding phone, gaming phone small but powerful phone. How important is this feature to you?
            </p>
            <Rating name={"excitement"} onRatingChange={setExcitement} />
        </Category>
        <Category>
            <h1>Ecosystem</h1>
            <p>
                Does ecosystem matter to you, Do you absolutely need iMessage, Facetime, AirDrop etc.
            </p>
            <Rating name={"ecosystem"} onRatingChange={setEcoSystem} />
        </Category>

        <Category>
            {typeOfPerson.type === "Tie" ? (
                <>
                    <p>
                        Based on your rating your result is a tie or indecisive, you can scroll back up and think and prioritize. This usually happens when you rate everything a 5, a 3 or not at all.
                    </p>
                </>) :
                (<>
                <h1>Based on your inputs you should buy a {typeOfPerson.type} Phone</h1>

                </>)}
        </Category>
    </div>
  );
}

export default App;
